import React, { useState } from 'react';
import * as styles from './TeamButton.module.scss';
import TeamMenu from './TeamMenu';
import useAppSelector from '../app/redux/useAppSelector';
import CaretButton from '../components/CaretButton';
import PopOverPrimitive from '../components/PopOverPrimitive';
import TeamIcon from '../organization/TeamIcon';
import Link from '../utils/router/Link';

const TeamButton = () => {
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);
  const name = useAppSelector((state) => state.session.organization.name);

  return (
    <div className={styles.teamButton}>
      <Link className={styles.logoContainer} to="/">
        <TeamIcon />
      </Link>
      <PopOverPrimitive
        trigger="click"
        placement="bottom-start"
        open={isPopOverOpen}
        onOpenChange={setIsPopOverOpen}
        offset={4}
      >
        <PopOverPrimitive.Trigger asChild>
          <CaretButton active={isPopOverOpen}>{name}</CaretButton>
        </PopOverPrimitive.Trigger>
        <PopOverPrimitive.Floating>
          <PopOverPrimitive.Content onClick={() => setIsPopOverOpen(false)}>
            <TeamMenu />
          </PopOverPrimitive.Content>
        </PopOverPrimitive.Floating>
      </PopOverPrimitive>
    </div>
  );
};

export default TeamButton;
